var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowingModalUseAhaSlidesFor)?_c('ModalUseAhaSlidesFor',{on:{"closePopup":function($event){_vm.isShowingModalUseAhaSlidesFor = false}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }